import { styled } from "goober";
import { Spinner } from "../Spinner";
import { Text } from "../Text";

const Overlay = styled("div")`
  position: sticky;
  top: 0;
  height: 12px;
  flex-shrink: 0;
  z-index: 1;
  pointer-events: none;
  > span {
    position: absolute;
    top: 4px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 8px;
    border-radius: 8px;
    background: var(--surface-primary);
    white-space: nowrap;
  }
`;

export function HistoryLoading() {
  return (
    <Overlay role="status">
      <Text variant="text-small" color="var(--text-secondary)">
        <Spinner size={10} />
        Loading older messages…
      </Text>
    </Overlay>
  );
}
